export default "__VITE_ASSET__BolOutJf__"